import View from 'proposals/components/layout/View'
import ViewHeader from 'proposals/proposal/views/ViewHeader'
import UserFlowCompleted from 'vendors/components/UserFlowCompleted'
import RequestForProposalBasicInfo from 'proposals/requestForProposal/RequestForProposalBasicInfo'
import Box from '@mui/material/Box'
import RequestForProposalDownloadPdf from 'proposals/requestForProposal/RequestForProposalDownloadPdf'
import { EditLayout } from 'proposals/proposal/views/ViewLayout'
import InfoBox from 'proposals/components/InfoBox'
import ProposalReadOnlyDetails from 'proposals/readOnly/ProposalReadOnlyDetails'
import { useGetProposalById } from 'proposals/queries/useProposalByIdQuery'
import { Navigate, useParams } from 'react-router-dom'
import { CircularProgress } from '@mui/material'
import { useTranslation } from 'react-i18next'

const ProposalReadOnlyView = () => {
  const { t } = useTranslation()
  const { proposalId } = useParams<{ proposalId: string }>()

  const { data, isLoading, isError } = useGetProposalById(proposalId as string)

  if (isError) {
    return <Navigate to={`/error`} replace />
  }

  if (isLoading || !data) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', flex: 1, alignItems: 'center' }}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  return (
    <UserFlowCompleted>
      <View>
        <EditLayout>
          <ViewHeader title={data.requestForProposal.title} logoUrl={data.requestForProposal.tenantLogoUrl} />
          <Box sx={{ gridArea: 'info', mt: 2 }}>
            <RequestForProposalBasicInfo data={data.requestForProposal} />
            <RequestForProposalDownloadPdf
              rfpId={data.requestForProposal.id}
              rfpTitle={data.requestForProposal.title}
            />
          </Box>
          <Box sx={{ gridArea: 'side-function', mt: 2 }}>
            <InfoBox text={t('proposal-read-only-info')} />
          </Box>
          <Box sx={{ gridArea: 'form' }}>
            <ProposalReadOnlyDetails proposal={data.proposal} fields={data.requestForProposal.fields} />
          </Box>
        </EditLayout>
      </View>
    </UserFlowCompleted>
  )
}

export default ProposalReadOnlyView
